import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import { updateCandidatePreferences } from 'actions/candidateActions';
import { fetchAllCountries } from 'actions/staticDataActions';
import { getCandidatePreferences, getCountries, getUserId, getAgencyId } from 'reducers';
import CandidateJourneyPreferencesFormView from './CandidateJourneyPreferencesFormView';
import CandidateJourneyPreferencesFormik from './CandidateJourneyPreferencesFormik';
import PrimaryButton from 'components/Shared/Buttons/PrimaryButton';
import PaperHeader from 'components/CandidateProfileJourney/SharedCandidateJourneyComponents/PaperElement/PaperHeader';
import PaperContent from 'components/CandidateProfileJourney/SharedCandidateJourneyComponents/PaperElement/PaperContent';
import PaperElement from 'components/CandidateProfileJourney/SharedCandidateJourneyComponents/PaperElement';
import UnsupportedLocationDialog from 'components/Shared/UnsupportedLocationDialog';

import './CandidateJourneyPreferences.scss';

const CandidateJourneyPreferences = ({
    userId,
    agencyId,
    candidatePreferences,
    updateCandidatePreferences,
    fetchAllCountries,
    countries,
    handleGoToNextStep,
}) => {
    const intl = useIntl();

    useEffect(() => {
        fetchAllCountries();
    }, []);

    const handleIsEarliestDateUnknownClick = (values, setValues) => {
        setValues({
            ...values,
            isEarliestDateUnknown: !values.isEarliestDateUnknown,
            earliestDate: !values.isEarliestDateUnknown ? null : candidatePreferences?.earliestDate,
        });
    };

    const updatePreferences = async (preferencesData, resetForm, stepData) => {
        await updateCandidatePreferences(agencyId, userId, preferencesData, stepData);
        resetForm();
    };

    const [isUnsupportedLocationDialogOpen, setIsUnsupportedLocationDialogOpen] = useState(false);

    const handleCloseUnsupportedLocationDialog = () => setIsUnsupportedLocationDialogOpen(false);

    return (
        <div className="candidate-journey-preferences">
            <CandidateJourneyPreferencesFormik
                candidatePreferences={candidatePreferences}
                updatePreferences={updatePreferences}
                handleGoToNextStep={handleGoToNextStep}
            >
                {(props) => (
                    <>
                        <div className="candidate-journey-preferences-view">
                            <PaperElement classes={[isMobile ? 'max' : 'sm']}>
                                <PaperHeader title={intl.formatMessage({ id: 'select-job-preferences' })} />
                                <PaperContent>
                                    <CandidateJourneyPreferencesFormView
                                        {...props}
                                        countries={countries}
                                        handleIsEarliestDateUnknownClick={handleIsEarliestDateUnknownClick}
                                        setIsUnsupportedLocationDialogOpen={setIsUnsupportedLocationDialogOpen}
                                    />
                                </PaperContent>
                            </PaperElement>
                        </div>
                        <div className="journey-buttons-wrapper">
                            <PrimaryButton text={intl.formatMessage({ id: 'continue' })} handleClick={props.handleSubmit} />
                        </div>
                    </>
                )}
            </CandidateJourneyPreferencesFormik>
            <UnsupportedLocationDialog
                isOpen={isUnsupportedLocationDialogOpen}
                handleCloseDialog={handleCloseUnsupportedLocationDialog}
            />
        </div>
    );
};
const mapStateToProps = (state) => ({
    candidatePreferences: getCandidatePreferences(state),
    countries: getCountries(state),
    agencyId: getAgencyId(state),
    userId: getUserId(state),
});

const mapDispatchToProps = {
    updateCandidatePreferences,
    fetchAllCountries,
};

export default connect(mapStateToProps, mapDispatchToProps)(CandidateJourneyPreferences); 
